import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TTL = 10 * 60 * 1000;
const cache = new Map();

const DEMO_STREAMS = [
  "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_ts/master.m3u8",
  "https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8",
];

export function xc(acc, action = "", params = {}) {
  const key = JSON.stringify([acc.server, acc.username, action, params]);
  const hit = cache.get(key);
  if (hit && Date.now() - hit.t < TTL) return hit.p;
  const p = axios
    .get(`${API}/xc`, {
      params: { server: acc.server, username: acc.username, password: acc.password, action, ...params },
      timeout: 60000,
    })
    .then((r) => r.data);
  cache.set(key, { p, t: Date.now() });
  p.catch(() => cache.delete(key));
  return p;
}

export const errMsg = (e) => e?.response?.data?.detail || (e?.code === "ECONNABORTED" ? "Server took too long to answer" : "Network error");

export const proxied = (url) => `${API}/stream?u=${encodeURIComponent(url)}`;

const DEMO_TS = "https://test-streams.mux.dev/x36xhzz/url_0/url_462/193039199_mp4_h264_aac_hd_7.ts";
const demoPick = (id) => proxied(DEMO_STREAMS[Number(id) % DEMO_STREAMS.length]);

function basePath(acc) {
  let base = acc.server.trim().replace(/\/+$/, "");
  if (!/^https?:\/\//i.test(base)) base = `http://${base}`;
  return `${base}/%T/${encodeURIComponent(acc.username)}/${encodeURIComponent(acc.password)}`;
}

export function vodSources(acc, type, id, ext) {
  const url = acc.server === "demo" ? demoPick(id) : proxied(`${basePath(acc).replace("%T", type)}/${id}.${ext || "mp4"}`);
  return [{ url, type: /m3u8/i.test(ext || "") ? "hls" : "file" }];
}

export function liveSources(acc, id, preferTs) {
  let hls, ts;
  if (acc.server === "demo") {
    hls = Number(id) > 32 ? proxied("https://test-streams.mux.dev/no-hls-here/index.m3u8") : demoPick(id);
    ts = proxied(DEMO_TS);
  } else {
    const b = basePath(acc).replace("%T", "live");
    hls = proxied(`${b}/${id}.m3u8`);
    ts = proxied(`${b}/${id}.ts`);
  }
  const h = { url: hls, type: "hls" };
  const t = { url: ts, type: "ts" };
  return preferTs ? [t, h] : [h, t];
}

export function catchupSources(acc, channelId, prog) {
  if (acc.server === "demo") return [{ url: demoPick(Number(prog.start_timestamp) / 3600), type: "hls" }];
  const mins = Math.ceil((Number(prog.stop_timestamp) - Number(prog.start_timestamp)) / 60);
  const [d, t] = String(prog.start).split(" ");
  const b = `${basePath(acc).replace("%T", "timeshift")}/${mins}/${d}:${t.slice(0, 5).replace(":", "-")}/${channelId}`;
  return [
    { url: proxied(`${b}.m3u8`), type: "hls" },
    { url: proxied(`${b}.ts`), type: "ts" },
  ];
}

export const fmtDuration = (s) => {
  s = Math.floor(s || 0);
  const h = Math.floor(s / 3600);
  const m = String(Math.floor((s % 3600) / 60)).padStart(h ? 2 : 1, "0");
  return `${h ? `${h}:` : ""}${m}:${String(s % 60).padStart(2, "0")}`;
};

export const fmtDay = (ts) =>
  new Date(Number(ts) * 1000).toLocaleDateString([], { weekday: "short", day: "numeric", month: "short" });

export const asList = (d) => (Array.isArray(d) ? d : d && typeof d === "object" ? Object.values(d) : []);

export function b64(s) {
  if (!s) return "";
  try {
    return decodeURIComponent(escape(atob(s)));
  } catch {
    return s;
  }
}

export const fmtTime = (ts) =>
  new Date(Number(ts) * 1000).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
